/**
 * The death report and the full-screen ownership moment (spec §9.2). Continue returns to the station screen.
 */
import type { ReactNode } from 'react'
import { FocusButton } from '../focus'
import { G } from '../models/layout'
import type { DeathModel, OwnershipModel } from '../models/moments'
import type { ScreenProps } from './common'

export function DeathScreen(p: ScreenProps & { model: DeathModel }): ReactNode {
  const { model, ctl } = p
  return (
    <div className="ui-moment ui-moment--death ui-panel" data-testid="death-screen">
      <p className="ui-moment__kicker">{model.title}</p>
      <h1 className="ui-moment__headline">{model.headline}</h1>
      {model.details.map((d) => (
        <p key={d} className="ui-moment__detail">
          {d}
        </p>
      ))}
      <FocusButton group={G.moment} index={0} testId="death-continue" className="ui-btn--wide" onActivate={() => ctl.run(() => ctl.actions.dismissScreen())}>
        Continue
      </FocusButton>
    </div>
  )
}

export function OwnershipScreen(p: ScreenProps & { model: OwnershipModel }): ReactNode {
  const { model, ctl } = p
  return (
    <div className="ui-moment ui-moment--owned" data-testid="ownership-screen">
      <p className="ui-moment__kicker">{model.subtitle}</p>
      <h1 className="ui-moment__title">{model.title}</h1>
      <p className="ui-moment__payoff">{model.payoff}</p>
      {model.details.map((d) => (
        <p key={d} className="ui-moment__detail">
          {d}
        </p>
      ))}
      <FocusButton group={G.moment} index={0} testId="ownership-continue" className="ui-btn--wide" onActivate={() => ctl.run(() => ctl.actions.dismissScreen())}>
        Continue
      </FocusButton>
    </div>
  )
}
